import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefresh = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 16,
	viewBox: "0 0 22 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 8.02539L6.59961 9.4248L5 7.8252V8C5 9.66667 5.5877 11.0833 6.7627 12.25C7.93763 13.4166 9.3666 14 11.0498 14C11.4831 14 11.9085 13.9496 12.3252 13.8496C12.7417 13.7496 13.15 13.6003 13.5498 13.4004L15.0498 14.9004C14.4166 15.267 13.7662 15.5413 13.0996 15.7246C12.433 15.9079 11.7497 16 11.0498 16C8.81656 16 6.91623 15.2248 5.34961 13.6748C3.78314 12.1249 3 10.2332 3 8V7.8252L1.40039 9.4248L0 8.02539L4 4.02539L8 8.02539ZM10.9502 0C13.1834 4.52272e-05 15.0838 0.77524 16.6504 2.3252C18.2169 3.87514 19 5.76681 19 8V8.1748L20.5996 6.5752L22 7.97461L18 11.9746L14 7.97461L15.4004 6.5752L17 8.1748V8C17 6.33333 16.4123 4.91667 15.2373 3.75C14.0624 2.58344 12.6334 2.00005 10.9502 2C10.5169 2 10.0915 2.05039 9.6748 2.15039C9.25834 2.25036 8.85001 2.39973 8.4502 2.59961L6.9502 1.09961C7.58343 0.733034 8.23383 0.458694 8.90039 0.275391C9.56697 0.0921055 10.2503 0 10.9502 0Z",
		fill: "currentColor"
	})
});
export default SvgRefresh;
